module.exports = __webpack_public_path__ + "img/thyc-xcb-table.b0dde1a2.png";